import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';

const Guide = ({ id, title, steps, note }) => (
  <Card data-testid={`guide-${id}`}>
    <CardHeader><CardTitle>{title}</CardTitle>{note && <CardDescription>{note}</CardDescription>}</CardHeader>
    <CardContent>
      <ol className="list-decimal pl-5 space-y-1 text-sm text-slate-700">
        {steps.map((s, i) => (<li key={i}>{s}</li>))}
      </ol>
    </CardContent>
  </Card>
);

export const GuidesSection = () => (
  <div className="space-y-6">
    <Guide
      id="tax-tables"
      title="Help guide 1 — Setting up & approving tax tables"
      note="Who: Finance. Two-person control is enforced throughout."
      steps={[
        'Open the Tax tables tab and choose New draft table. Pick the table type — federal income, FICA, FUTA, state income, SUTA, a state program (e.g. DC PFL, Maryland FAMLI), local income, reciprocity or CCPA.',
        'Fill the guided form — plain dollar and percent fields, with bracket tables entered as editable rows (Add row / Remove row). You never paste or edit JSON.',
        'Prefer a spreadsheet? Click Download Excel template for that exact type, fill it (percents as percents, dollars as dollars), and upload it back — every table type has its own template.',
        'Save the Draft. A second Finance user opens it and clicks Approve. The author can never approve their own table — this is the two-person control.',
        'Seeded starter tables are synthetic preview data. In preview they are labelled “Approved (seed, Finance must verify)”; in production they are withdrawn and labelled “Withdrawn (seed, not for production)” so they never drive a real run. Either way, Finance must enter and approve verified tables before relying on them.',
        'Approving a new version automatically supersedes the previously approved table for the same type, jurisdiction, year and frequency.',
        'Only Approved tables in effect on the pay date are used by the engine. If a needed table is missing, the calculator stops and names the jurisdiction — it never returns a silent zero.',
        'At year end, use Copy forward to seed next year from last year’s approved table, then verify and re-approve.',
      ]}
    />
    <Guide
      id="parallel-test"
      title="Help guide 2 — Running the parallel net-pay test"
      note="Who: Finance. Nothing here posts to pay runs, the ledger, banking or NACHA."
      steps={[
        'Confirm employee tax setup is complete (Tax setup tab) and that deduction codes, elections and garnishments are entered (Deductions & garnishments tab).',
        'Use the Test calculator to spot-check a single paycheck and read the method trace for each line (including supplemental pay and CCPA-capped garnishments).',
        'Import the WinTeam Payroll Check History for the check date (Imports tab), review the version, then Finalize it.',
        'In the Comparison tab, run a parallel net-pay run for the same checks to get a run id.',
        'Enter the run id and the WinTeam check date and click Compare to see every line, employee by employee, matched or flagged to the penny.',
        'Read the summary card for the net match rate and top difference reasons, then Export CSV or Excel to review the full detail offline.',
      ]}
    />
  </div>
);
